export default __webpack_public_path__ + "static/media/UBQR.c93721e7.png";